// ============================================================
// OLD CANCELLATION ADDRESS PAGE (commented out)
// ============================================================
// import React from "react";
// import { dateFormatter } from "../../../../utils/dateFormatter";
// import classes from "./cancellationAddressPage.module.css";
//
// export const CancellationAddressPage = ({ address }) => {
//   return (
//     <div className={classes.box}>
//       <div className={classes.box__grid}>
//         <div className={classes.box__upper}>
//           <div className={classes.box__content}>
//             <h1 className={classes.box__content__key}>Order ID : </h1>
//             <h1 className={classes.box__content__value}>{address?.order_id}</h1>
//           </div>
//           <div className={classes.box__content}>
//             <h1 className={classes.box__content__key}>Date :</h1>
//             <h1 className={classes.box__content__value}>{dateFormatter(address?.ordered_on)}</h1>
//           </div>
//         </div>
//         <div className={classes.box__upper}>
//           <div className={classes.box__content}>
//             <h1 className={classes.box__content__key}>No. of Items :</h1>
//             <h1 className={classes.box__content__value}>{address?.num_of_items}</h1>
//           </div>
//           <div className={classes.box__content}>
//             <h1 className={classes.box__content__key}>Total Amt :</h1>
//             <h1 className={classes.box__content__value}>Rs.{address?.total_amount}</h1>
//           </div>
//         </div>
//         <hr className={classes.box__sep} />
//         <div className={classes.box__lower}>
//           <div className={classes.box__lower__content}>
//             <div className={classes.box__content}>
//               <h1 className={classes.box__content__key}>Name:</h1>
//               <h1 className={classes.box__content__value}>{address?.name}</h1>
//             </div>
//             <div className={classes.box__content}>
//               <h1 className={classes.box__content__key}>Phone Number:</h1>
//               <h1 className={classes.box__content__value}>{address?.mobile_no}</h1>
//             </div>
//           </div>
//           <div className={classes.box__content__address}>
//             <h1 className={classes.box__content__key}>Address:</h1>
//             <h1 className={classes.box__content__value}>{address?.address}</h1>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// ============================================================

import React from "react";
import { dateFormatter } from "../../../../utils/dateFormatter";
import classes from "./cancellationAddressPage.module.css";
import { StatusBadge } from "../../../../component/bulk/bulkSpares/bulkSparesDetail/BulkSpareDetailForm";

export const CancellationAddressPage = ({ address }) => {
  return (
    <div className={classes.box}>
      {/* TOP SUMMARY */}
      <div className={`${classes.card} ${classes.cardHighlight}`}>
        <div className={classes.box__section}>
          <div className={classes.box__section__top}>
            <InfoRow label="Order Id" value={`#${address?.order_id}`} />
            <StatusBadge status={address?.order_status} />
          </div>
          <InfoRow label="Date" value={dateFormatter(address?.ordered_on)} />
          <InfoRow label="Items" value={address?.num_of_items} />
          <InfoRow label="Amount" value={`₹${address?.total_amount}`} />
        </div>
      </div>

      {/* CUSTOMER */}
      <div className={classes.card}>
        <h3 className={classes.sectionTitle}>Customer Information</h3>
        <InfoRow label="Name" value={address?.name} />
        <InfoRow label="Phone" value={address?.mobile_no} />
      </div>

      {/* DELIVERY */}
      <div className={classes.card}>
        <h3 className={classes.sectionTitle}>Delivery Information</h3>
        <InfoRow label="Address" value={address?.address} />
      </div>
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div className={classes.row}>
    <span className={classes.row__label}>{label}</span>
    <span className={classes.row__value}>{value || "-"}</span>
  </div>
);
